import net from "@/Scripts/app/net";
/* eslint-disable */

// Helper function to check if we're in development environment
function isEnvDevelopment() {
  console.log('Environment:', process.env.NODE_ENV, process.env.VUE_APP_ENV);
  return process.env.NODE_ENV !== 'production' &&
    process.env.VUE_APP_ENV !== 'production';

}

class DataQualityClient {
  constructor() { }
  getFleetOverview() {
    return net.get("/DataQuality/FleetOverview");
  }
  getDataOutage() {
    return net.get("/DataQuality/DataOutage");
  }
  getDataOutageConfig() {
    return net.get("/DataQuality/DataOutage/Configuration");
  }
  updateDataOutageConfig(config) {
    return net.put("/DataQuality/DataOutage/Configuration", config);
  }
  async getCompanyOutliers(query) {
    // @params query = { companyId, fromDate?, toDate? };
    const response = await net.get(`/DataQuality/CompanyOutliers`, query);
    return response;
  }
  getFeatureConfigs(query) {
    // @params query = { vesselId };
    return net.get(`/DataQuality/Outliers/Config`, query);
  }
  updateFeatureConfigs(config) {
    return net.post(`/DataQuality/Outliers/Config`, config);
  }
  recalculateOutliers(query) {
    // @params query = { vesselId };
    return net.post(`/DataQuality/Outliers/RecalculateAll?vesselID=${query.vesselId}`);
  }
  getFeatureValues() {
    return net.get(`/datafeature`);
  }
  getFeatures() {
    return net.get("/DataQuality/Features");
  }
  getCompanyFeatures(query) {
    // @params query = { companyId }
    return net.get("/DataQuality/company-features", query);
  }
  getAvailabilityFeatures(query) {
    // @params query = { companyId }
    return net.get("/DataQuality/availability-features", query);
  }
  setAvailabilityFeatures(companyId, featureNames) {
    return net.post(`/DataQuality/availability-features?companyId=${companyId}`, featureNames);
  }
  getOutlierFeatures(query) {
    // @params query = { companyId }
    return net.get("/DataQuality/outlier-features", query);
  }
  setOutlierFeatures(companyId, featureNames) {
    return net.post(`/DataQuality/outlier-features?companyId=${companyId}`, featureNames);
  }
  updateOutliersAcknowledge(tags) {
    return net.put("/DataQuality/Outliers/TakeAction/Acknowledge", tags);
  }
  updateOutliersRemove(tags) {
    return net.put("/DataQuality/Outliers/TakeAction/Delete", tags);
  }
  updateOutliersClear(tags) {
    return net.put("/DataQuality/Outliers/TakeAction/Clear", tags);
  }
  getSpeedLog(query) {
    query.featureName = "Speed Through Water";
    return net.get("/DataQuality/SpeedLog", query);
  }
  getDerivedSpeedThroughWater(query) {
    return net.get("/DataQuality/SpeedLog/DerivedSpeedThroughWater", query);
  }

  getSpeedThroughWater(query) {
    return net.get("/DataQuality/SpeedLog/SpeedThroughWater", query);
  }

  getDataAlignment(query) {
    return net.get("/DataQuality/DataAlignment", query);
  }


  async getOutlierTimeline(query) {
    // @params query = { vesselId, featureName, from, to }
    const response = await net.get("/DataQuality/OutlierTimeline", query);

    return response;
  }

  async updateAutoRemoveConfig(data) {
    // @params data = { vesselId, enabled }
    return net.put("/DataQuality/Outliers/AutoRemove", data);
  }
}

export default new DataQualityClient();
